"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1399],{

/***/ 331399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Layout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(999534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(809008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/redux/actions/storeInfo.js
var actions_storeInfo = __webpack_require__(117321);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(731024);
// EXTERNAL MODULE: ./src/utils/LocalStorageHelper.js
var LocalStorageHelper = __webpack_require__(644779);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(960357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/@dotpe/kui/styles/theme/generate.js
var generate = __webpack_require__(472327);
// EXTERNAL MODULE: ./node_modules/@dotpe/kui/styles/theme/theme.js
var theme = __webpack_require__(952301);
;// CONCATENATED MODULE: ./src/components/Layout/theme.tsx




var ThemeCss = function() {
    var cssTheme = (0,generate.getCssFromThemeObject)(theme.theme);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (0,jsx_runtime.jsx)((style_default()), {
            id: cssTheme.__hash,
            children: cssTheme
        })
    });
};

// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./src/utils/constants/images.js
var constants_images = __webpack_require__(284320);
// EXTERNAL MODULE: ./src/hooks/useStoreContactDetails.tsx
var useStoreContactDetails = __webpack_require__(299375);
// EXTERNAL MODULE: ./src/components/Layout/utils.ts
var utils = __webpack_require__(29806);
;// CONCATENATED MODULE: ./src/components/Layout/RichSnippetStoreDetails.tsx







var RichSnippetStoreDetails = function(props) {
    var ref, ref1;
    var ref2 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref, ref1;
        return {
            storeFromSelector: (ref = state.storeReducer) === null || ref === void 0 ? void 0 : ref.store,
            storePolicy: ((ref1 = state.storePolicyReducer) === null || ref1 === void 0 ? void 0 : ref1.data[0]) || null
        };
    }), storeFromSelector = ref2.storeFromSelector, storePolicy = ref2.storePolicy;
    var store = props.store || storeFromSelector;
    var storeData = {
        logo_image: (store === null || store === void 0 ? void 0 : store.logo_image) || constants_images/* DEFAULT_SSR_IMAGE_URL */.a,
        store_url: store === null || store === void 0 ? void 0 : store.store_url,
        description: (store === null || store === void 0 ? void 0 : store.description) || "",
        store_name: store === null || store === void 0 ? void 0 : store.store_name,
        display_number: store === null || store === void 0 ? void 0 : store.display_phone
    };
    var storeAddress = store === null || store === void 0 ? void 0 : store.address;
    var ref3 = (0,useStoreContactDetails/* default */.Z)(true), storeEmail = ref3.storeEmail, storePhone = ref3.storePhone;
    var socialMediaLink = (0,utils/* getSocialMediaLink */.HJ)(store === null || store === void 0 ? void 0 : store.social_media_profile_details);
    var isReturnPolicy = storePolicy === null || storePolicy === void 0 ? void 0 : (ref = storePolicy.additional_config_return_refund_policy) === null || ref === void 0 ? void 0 : ref.is_accepting_returns;
    var refundDay = storePolicy === null || storePolicy === void 0 ? void 0 : (ref1 = storePolicy.additional_config_return_refund_policy) === null || ref1 === void 0 ? void 0 : ref1.day_count;
    var hasValidStoreData = (storeData === null || storeData === void 0 ? void 0 : storeData.logo_image) && (storeData === null || storeData === void 0 ? void 0 : storeData.store_url);
    var storeSchema = (0,_object_spread/* default */.Z)({
        "@context": "https://www.schema.org",
        "@type": "OnlineStore",
        name: storeData === null || storeData === void 0 ? void 0 : storeData.store_name,
        description: storeData === null || storeData === void 0 ? void 0 : storeData.description,
        url: storeData === null || storeData === void 0 ? void 0 : storeData.store_url,
        logo: storeData === null || storeData === void 0 ? void 0 : storeData.logo_image,
        contactPoint: (0,_object_spread/* default */.Z)({
            "@type": "ContactPoint",
            contactType: "Customer Service"
        }, storePhone && {
            telephone: storePhone
        }, storeEmail && {
            email: storeEmail
        })
    }, socialMediaLink.length && {
        sameAs: socialMediaLink
    }, isReturnPolicy ? {
        hasMerchantReturnPolicy: {
            "@type": "MerchantReturnPolicy",
            returnPolicyCategory: "https://schema.org/MerchantReturnFiniteReturnWindow ",
            merchantReturnDays: refundDay,
            applicableCountry: "IN",
            returnPolicyCountry: "IN"
        }
    } : {
        hasMerchantReturnPolicy: {
            "@type": "MerchantReturnPolicy",
            returnPolicyCategory: "https://schema.org/MerchantReturnNotPermitted"
        }
    }, (storeAddress === null || storeAddress === void 0 ? void 0 : storeAddress.address_1) && {
        address: {
            "@type": "PostalAddress",
            streetAddress: (storeAddress === null || storeAddress === void 0 ? void 0 : storeAddress.address_1) || "",
            addressLocality: (storeAddress === null || storeAddress === void 0 ? void 0 : storeAddress.city) || "",
            addressCountry: "IN",
            addressRegion: (storeAddress === null || storeAddress === void 0 ? void 0 : storeAddress.state) || "",
            postalCode: (storeAddress === null || storeAddress === void 0 ? void 0 : storeAddress.pincode) || ""
        }
    });
    return hasValidStoreData ? /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(storeSchema)
        }
    }) : null;
};

// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(482516);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(505152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/utils/checkIfThemeEditorOrPreview.js
var checkIfThemeEditorOrPreview = __webpack_require__(135069);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/utils.tsx
var WidgetDnD_utils = __webpack_require__(844369);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(474151);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/GlobalStyle/globalSettingConstant.tsx
var globalSettingConstant = __webpack_require__(688403);
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(682492);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(150361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./src/constants/globalConfigs.ts
var globalConfigs = __webpack_require__(337392);
;// CONCATENATED MODULE: ./src/components/Layout/component/AnalyticsTags/GoogleAnalyticsScript.tsx

function GoogleAnalyticsScript(param) {
    var analyticsId = param.analyticsId;
    // useEffect(() => {
    //   if (!analyticsId) return;
    //   const loadAnalytics = () => {
    //     // 1. Load the GA4 gtag.js script
    //     const script = document.createElement('script');
    //     script.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsId}`;
    //     script.async = true;
    //     document.head.appendChild(script);
    //     // 2. Inject the gtag config script
    //     const inlineScript = document.createElement('script');
    //     inlineScript.innerHTML = `
    //       window.dataLayer = window.dataLayer || [];
    //       function gtag(){dataLayer.push(arguments);}
    //       gtag('js', new Date());
    //       gtag('config', '${analyticsId}');
    //     `;
    //     document.head.appendChild(inlineScript);
    //   };
    //   if (document.readyState === 'loading') {
    //     document.addEventListener('DOMContentLoaded', loadAnalytics);
    //   } else {
    //     loadAnalytics();
    //   }
    //   return () => {
    //     document.removeEventListener('DOMContentLoaded', loadAnalytics);
    //   };
    // }, [analyticsId]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                async: true,
                src: "https://www.googletagmanager.com/gtag/js?id=".concat(analyticsId)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: "\n                    window.dataLayer = window.dataLayer || [];\n                    function gtag(){dataLayer.push(arguments);}\n                    gtag('js', new Date());\n                    gtag('config', '".concat(analyticsId, "');\n                  ")
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Layout/component/AnalyticsTags/GoogleAdsScript.tsx

function GoogleAdsScript(param) {
    var adTagId = param.adTagId;
    // useEffect(() => {
    //   if (!adTagId) return;
    //   const loadGoogleAds = () => {
    //     // 1. Load the Google Ads gtag.js script
    //     const script = document.createElement('script');
    //     script.src = `https://www.googletagmanager.com/gtag/js?id=${adTagId}`;
    //     script.async = true;
    //     document.head.appendChild(script);
    //     // 2. Inject config/init script
    //     const inlineScript = document.createElement('script');
    //     inlineScript.innerHTML = `
    //       window.dataLayer = window.dataLayer || [];
    //       function gtag(){dataLayer.push(arguments);}
    //       gtag('js', new Date());
    //       gtag('config', '${adTagId}');
    //     `;
    //     document.head.appendChild(inlineScript);
    //   };
    //   if (document.readyState === 'loading') {
    //     document.addEventListener('DOMContentLoaded', loadGoogleAds);
    //   } else {
    //     loadGoogleAds();
    //   }
    //   return () => {
    //     document.removeEventListener('DOMContentLoaded', loadGoogleAds);
    //   };
    // }, [adTagId]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                async: true,
                src: "https://www.googletagmanager.com/gtag/js?id=".concat(adTagId)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: "\n                window.dataLayer = window.dataLayer || [];\n                function gtag(){dataLayer.push(arguments);}\n                gtag('js', new Date());\n                gtag('config', '".concat(adTagId, "');\n              ")
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Layout/component/AnalyticsTags/StoreMarketingTagScripts.tsx

function StoreMarketingTagScripts(param) {
    var gtagId = param.gtagId;
    // useEffect(() => {
    //   if (!gtagId) return;
    //   const handleLoad = () => {
    //     // 1. Load the gtag.js script
    //     const gtagScript = document.createElement('script');
    //     gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
    //     gtagScript.async = true;
    //     document.head.appendChild(gtagScript);
    //     // 2. Inject GTM bootstrap script
    //     const gtmScript = document.createElement('script');
    //     gtmScript.innerHTML = `
    //       (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    //       new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    //       j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    //       'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    //       })(window,document,'script','dataLayer','${gtagId}');
    //     `;
    //     document.head.appendChild(gtmScript);
    //     // 3. Add gtag config script
    //     const configScript = document.createElement('script');
    //     configScript.innerHTML = `
    //       window.dataLayer = window.dataLayer || [];
    //       function gtag(){dataLayer.push(arguments);}
    //       gtag('js', new Date());
    //       gtag('config', '${gtagId}');
    //     `;
    //     document.head.appendChild(configScript);
    //   };
    //   // Run on DOMContentLoaded
    //   if (document.readyState === 'loading') {
    //     document.addEventListener('DOMContentLoaded', handleLoad);
    //   } else {
    //     handleLoad();
    //   }
    //   return () => {
    //     document.removeEventListener('DOMContentLoaded', handleLoad);
    //   };
    // }, [gtagId]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                async: true,
                src: "https://www.googletagmanager.com/gtag/js?id=".concat(gtagId)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: "\n            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n            '//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n            })(window,document,'script','dataLayer','".concat(gtagId, "');\n          ")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: "\n              window.dataLayer = window.dataLayer || [];\n              function gtag(){dataLayer.push(arguments);}\n              gtag('js', new Date());\n              gtag('config', '".concat(gtagId, "');")
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Layout/component/AnalyticsTags/DSAnalyticsScript.tsx

function DSAnalyticsScript(param) {
    var _gtagId = param.gtagId, gtagId = _gtagId === void 0 ? "G-LLCH0NYZ61" : _gtagId;
    // useEffect(() => {
    //   if (!gtagId) return;
    //   const loadGA4 = () => {
    //     // 1. Load the gtag.js library
    //     const gtagScript = document.createElement('script');
    //     gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
    //     gtagScript.async = true;
    //     document.head.appendChild(gtagScript);
    //     // 2. Initialize gtag
    //     const initScript = document.createElement('script');
    //     initScript.innerHTML = `
    //       window.dataLayer = window.dataLayer || [];
    //       function gtag(){dataLayer.push(arguments);}
    //       gtag('js', new Date());
    //       gtag('config', '${gtagId}');
    //     `;
    //     document.head.appendChild(initScript);
    //   };
    //   if (document.readyState === 'loading') {
    //     document.addEventListener('DOMContentLoaded', loadGA4);
    //   } else {
    //     loadGA4();
    //   }
    //   return () => {
    //     document.removeEventListener('DOMContentLoaded', loadGA4);
    //   };
    // }, [gtagId]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                async: true,
                src: "https://www.googletagmanager.com/gtag/js?id=".concat(gtagId)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: "\n              window.dataLayer = window.dataLayer || [];\n              function gtag(){dataLayer.push(arguments);}\n              gtag('js', new Date());\n              gtag('config', ".concat(gtagId, ");")
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Layout/component/AnalyticsTags/index.tsx






function GoogleTags(param) {
    var store = param.store, featureLocksStatus = param.featureLocksStatus;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var googleTagFeatureStatus = featureLocksStatus.googleTagFeatureStatus, googleAnalyticsFeatureStatus = featureLocksStatus.googleAnalyticsFeatureStatus, fbPixelFeatureStatus = featureLocksStatus.fbPixelFeatureStatus;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (store === null || store === void 0 ? void 0 : (ref = store.store_marketing_tags) === null || ref === void 0 ? void 0 : ref.facebook_pixel) && !(fbPixelFeatureStatus === null || fbPixelFeatureStatus === void 0 ? void 0 : fbPixelFeatureStatus.isLocked) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        dangerouslySetInnerHTML: {
                            __html: "\n                      !function(f,b,e,v,n,t,s)\n                      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n                      n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n                      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n                      n.queue=[];t=b.createElement(e);t.async=!0;\n                      t.src=v;s=b.getElementsByTagName(e)[0];\n                      s.parentNode.insertBefore(t,s)}(window, document,'script',\n                      'https://connect.facebook.net/en_US/fbevents.js');\n                      fbq('init', '".concat(store === null || store === void 0 ? void 0 : store.store_marketing_tags.facebook_pixel, "');\n                      fbq('track', 'PageView');\n                    ")
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            height: "1",
                            width: "1",
                            style: {
                                display: "none"
                            },
                            src: "https://www.facebook.com/tr?id=".concat(store === null || store === void 0 ? void 0 : store.store_marketing_tags.facebook_pixel, "&ev=PageView&noscript=1")
                        })
                    })
                ]
            }),
            (store === null || store === void 0 ? void 0 : (ref1 = store.store_marketing_tags) === null || ref1 === void 0 ? void 0 : ref1.google_analytics) && !(googleAnalyticsFeatureStatus === null || googleAnalyticsFeatureStatus === void 0 ? void 0 : googleAnalyticsFeatureStatus.isLocked) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleAnalyticsScript, {
                analyticsId: store === null || store === void 0 ? void 0 : (ref2 = store.store_marketing_tags) === null || ref2 === void 0 ? void 0 : ref2.google_analytics
            }),
            (store === null || store === void 0 ? void 0 : (ref3 = store.store_marketing_tags) === null || ref3 === void 0 ? void 0 : ref3.google_ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleAdsScript, {
                adTagId: store === null || store === void 0 ? void 0 : (ref4 = store.store_marketing_tags) === null || ref4 === void 0 ? void 0 : ref4.google_ads
            }),
            (store === null || store === void 0 ? void 0 : (ref5 = store.store_marketing_tags) === null || ref5 === void 0 ? void 0 : ref5.g_tag) && !(googleTagFeatureStatus === null || googleTagFeatureStatus === void 0 ? void 0 : googleTagFeatureStatus.isLocked) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreMarketingTagScripts, {
                gtagId: store === null || store === void 0 ? void 0 : (ref6 = store.store_marketing_tags) === null || ref6 === void 0 ? void 0 : ref6.g_tag
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DSAnalyticsScript, {})
        ]
    });
}

// EXTERNAL MODULE: ./src/utils/useCheckIfHomePage.ts
var useCheckIfHomePage = __webpack_require__(576609);
// EXTERNAL MODULE: ./src/redux/actions/wishlist.ts
var wishlist = __webpack_require__(847228);
// EXTERNAL MODULE: ./src/constants/wishlist.js
var constants_wishlist = __webpack_require__(298627);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(506337);
;// CONCATENATED MODULE: ./src/utils/shouldBlockRobotCrawler.js

/**
 * Determines whether robots (web crawlers) should be blocked based on the current hostname.
 *
 * @returns {boolean} Returns `true` if the current hostname matches any of the blocked domains, otherwise `false`.
 */ function shouldBlockRobots() {
    var hostname = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (!hostname && checkRenderEnv/* IS_CLIENT */.kc) {
        var ref;
        hostname = window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.hostname;
    }
    var blockedDomains = [
        "showroom.dotpe.in"
    ];
    return blockedDomains === null || blockedDomains === void 0 ? void 0 : blockedDomains.some(function(domain) {
        return hostname === domain || hostname.endsWith(".".concat(domain));
    });
}

;// CONCATENATED MODULE: ./src/components/Layout/index.tsx
/**
 * Common Layout
 */ 





























// import GTMNoScript from './component/AnalyticsTags/GTMNoScript';
var PromoModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6856).then(__webpack_require__.bind(__webpack_require__, 10682)).then(function(mod) {
        return mod.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10682)
            ];
        }
    },
    ssr: false
});
var PromoRemovalAlertModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8843).then(__webpack_require__.bind(__webpack_require__, 838843)).then(function(mod) {
        return mod.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(838843)
            ];
        }
    },
    ssr: false
});
var WhatsAppLeadGenerationModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9342).then(__webpack_require__.bind(__webpack_require__, 9342)).then(function(mod) {
        return mod.WhatsAppLeadGenerationModal;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9342)
            ];
        }
    },
    ssr: false
});
var B2bRfqFormModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7856), __webpack_require__.e(9228), __webpack_require__.e(5914), __webpack_require__.e(2878), __webpack_require__.e(9748), __webpack_require__.e(2945)]).then(__webpack_require__.bind(__webpack_require__, 329748)).then(function(mod) {
        return mod.B2bRfqFormModal;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(329748)
            ];
        }
    },
    ssr: false
});
var RedirectionToWebConsoleModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(4070)]).then(__webpack_require__.bind(__webpack_require__, 844070));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(844070)
            ];
        }
    },
    ssr: false
});
var InaccessibleLayer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4273).then(__webpack_require__.bind(__webpack_require__, 54273));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(54273)
            ];
        }
    },
    ssr: false
});
var ExitGatingModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 729).then(__webpack_require__.bind(__webpack_require__, 680729));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(680729)
            ];
        }
    },
    ssr: false
});
var IS_SERVER = "object" === "undefined";
var Layout = function(_param) {
    var getGoogleSiteVerificationTag = function getGoogleSiteVerificationTag() {
        var ref;
        if (store === null || store === void 0 ? void 0 : (ref = store.store_marketing_tags) === null || ref === void 0 ? void 0 : ref.gmc_verification) {
            var ref1;
            return store === null || store === void 0 ? void 0 : (ref1 = store.store_marketing_tags) === null || ref1 === void 0 ? void 0 : ref1.gmc_verification;
        }
        if (shouldBlockRobots(hostname)) {
            return "mK1bfkPj0S87QshVGQYkh19-SjVByGSE7V976iYPeLs";
        }
        return "";
    };
    var store = _param.store, _title = _param.title, title = _title === void 0 ? "" : _title, _Icon = _param.Icon, Icon = _Icon === void 0 ? "" : _Icon, _favIcon = _param.favIcon, favIcon = _favIcon === void 0 ? "" : _favIcon, _metaDescription = _param.metaDescription, metaDescription = _metaDescription === void 0 ? "" : _metaDescription, _OGTitle = _param.OGTitle, OGTitle = _OGTitle === void 0 ? "" : _OGTitle, _OGDescription = _param.OGDescription, OGDescription = _OGDescription === void 0 ? "" : _OGDescription, _OGImage = _param.OGImage, OGImage = _OGImage === void 0 ? "" : _OGImage, children = _param.children, _keywords = _param.keywords, keywords = _keywords === void 0 ? "" : _keywords, _canonicalTagUrl = _param.canonicalTagUrl, canonicalTagUrl = _canonicalTagUrl === void 0 ? "" : _canonicalTagUrl, props = (0,_object_without_properties/* default */.Z)(_param, [
        "store",
        "title",
        "Icon",
        "favIcon",
        "metaDescription",
        "OGTitle",
        "OGDescription",
        "OGImage",
        "children",
        "keywords",
        "canonicalTagUrl"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var isRedirectedToHome = (0,react.useRef)(false);
    var ref17 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref17.widgetContextState, globalSettings = _widgetContextState.globalSettings, isBuilder = _widgetContextState.isBuilder, _widgetContextActions = ref17.widgetContextActions, setGlobalSetting = _widgetContextActions.setGlobalSetting, setGlobalStyle = _widgetContextActions.setGlobalStyle;
    var ref18 = (0,react.useState)({
        showInaccessibleView: false,
        showRedirectionModal: false
    }), showState = ref18[0], setShowState = ref18[1];
    var ref19 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store,
            globalStyleSSR: state.jsonWidgetsReducer.globalStyle || {},
            shouldLoadFeatureLocks: !state.commonReducer.featureLocksData.isFeatureLocksLoaded
        };
    }), storeData = ref19.storeData, shouldLoadFeatureLocks = ref19.shouldLoadFeatureLocks, globalStyleSSR = ref19.globalStyleSSR;
    var ref20 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref;
        return {
            userData: state.userReducer,
            toggleMobileView: state.commonReducer.toggleMobileView,
            isLoginByEmail: !!((ref = state.userReducer.data) === null || ref === void 0 ? void 0 : ref.email)
        };
    }), userData = ref20.userData, toggleMobileView = ref20.toggleMobileView, isLoginByEmail = ref20.isLoginByEmail;
    // Global modal states
    var ref21 = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1, ref2;
        return {
            showWhatsAppLeadModal: (ref = state.commonReducer) === null || ref === void 0 ? void 0 : (ref1 = ref.whatsAppLeadModalState) === null || ref1 === void 0 ? void 0 : ref1.show,
            promoRemovalAlertModalState: ((ref2 = state.commonReducer) === null || ref2 === void 0 ? void 0 : ref2.promoRemovalAlertModalState) || {},
            promoModalState: state.commonReducer.promoDetailModalState || {}
        };
    }), showWhatsAppLeadModal = ref21.showWhatsAppLeadModal, promoRemovalAlertModalState = ref21.promoRemovalAlertModalState, promoModalState = ref21.promoModalState;
    var storeInfo = store || storeData;
    var storeId = (props === null || props === void 0 ? void 0 : (ref = props.storeInfo) === null || ref === void 0 ? void 0 : ref.store_id) || (storeData === null || storeData === void 0 ? void 0 : storeData.store_id);
    var hostname = (props === null || props === void 0 ? void 0 : props.hostName) || (IS_SERVER ? "" : window.location.hostname);
    var featureLocksStatus = (0,useFeatureLocks/* useFeatureLocks */.r)();
    var memberOnlyLoginFeatureStatus = featureLocksStatus.memberOnlyLoginFeatureStatus;
    var isMolUnlocked = (memberOnlyLoginFeatureStatus === null || memberOnlyLoginFeatureStatus === void 0 ? void 0 : memberOnlyLoginFeatureStatus.isLocked) === false;
    var isBrandWebsiteDemo = router.pathname.includes("/brand-website-theme-demo");
    var isAboutPage = router.pathname.includes("".concat(routes.PATH.DOMAIN_HOME).concat(routes.PATH.ABOUT_US));
    var isHomePage = (0,useCheckIfHomePage/* useCheckIfHomePage */.t)();
    var ref22;
    var gtmId = (ref22 = store === null || store === void 0 ? void 0 : (ref1 = store.store_marketing_tags) === null || ref1 === void 0 ? void 0 : ref1.g_tag) !== null && ref22 !== void 0 ? ref22 : "GTM-N8T6CPZ";
    (0,react.useEffect)(function() {
        var ref, ref1;
        if ((0,checkIfThemeEditorOrPreview/* default */.Z)() && !isBrandWebsiteDemo) {
            var bodyElement = document.getElementsByTagName("body")[0];
            if (bodyElement) {
                bodyElement.style = "pointer-events: none";
            }
        }
        if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.store_type_flag) === constants/* B2B_STORE_TYPE_CONSTANT */.CB && (userData === null || userData === void 0 ? void 0 : userData.isLogin)) {
            dispatch((0,actions_storeInfo/* getB2bRfqInputFields */.f2)(undefined, storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id));
        }
        if ((userData === null || userData === void 0 ? void 0 : userData.isLogin) && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.services) === null || ref1 === void 0 ? void 0 : ref1.wishlist_flag) !== constants_wishlist/* WISHLIST_FEATURE_STATUS.WISHLIST_INACTIVE */.g.WISHLIST_INACTIVE) {
            dispatch((0,wishlist/* getWishlistItemCountByUser */.OG)({
                store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id
            }));
        }
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        var shouldRedirectToMOL = !(0,checkIfThemeEditorOrPreview/* default */.Z)() && isMolUnlocked && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.members_only_access) && !LocalStorageHelper/* default.get */.Z.get("isMemberAllowed&store_id=".concat(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id)) && !router.pathname.includes(routes.PATH.MEMBER_LOGIN) && !router.pathname.includes(routes.PATH.BUILDER_PREVIEW);
        if (shouldRedirectToMOL && !props.isBuilder) {
            var ref1;
            var memberLoginRoute = (0,routes.getRoute)(routes.PATH.MEMBER_LOGIN, storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain);
            router.replace(memberLoginRoute);
        }
    }, [
        isMolUnlocked
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var globalStyleData = cloneDeep_default()(globalStyleSSR);
        if (globalStyleData && ((ref = Object.keys(globalStyleData || {})) === null || ref === void 0 ? void 0 : ref.length)) {
            var globalStyleDataClone = {};
            for(var key in globalStyleData){
                if (globalConfigs/* GLOBAL_STYLE */.$[key] && globalStyleData[key]) globalStyleDataClone[key] = merge_default()(globalConfigs/* GLOBAL_STYLE */.$[key], globalStyleData[key]);
            }
            setGlobalStyle(globalStyleDataClone);
            var updatedGlobalSetting = (0,WidgetDnD_utils.getUpdatedGlobalSetting)(globalStyleDataClone, globalSettings);
            setGlobalSetting(updatedGlobalSetting);
        }
    }, [
        globalStyleSSR
    ]);
    /**
   * Instead of putting this sequence of code in every container,
   * we can put it here and reduce the number of lines of code.
   * If there are any special ones, the can be put in respective
   * containers.
   *
   * These four are common and used thorughout the pages and containers
   */ (0,react.useEffect)(function() {
        /* Save store info */ if (Object.keys((props === null || props === void 0 ? void 0 : props.storeInfo) || {}).length) {
            dispatch((0,actions_storeInfo/* saveStoreInfo */.nx)((props === null || props === void 0 ? void 0 : props.storeInfo) || {}));
        }
    }, [
        props === null || props === void 0 ? void 0 : props.storeInfo
    ]);
    (0,react.useEffect)(function() {
        if (storeId) {
            dispatch((0,catalog/* getCustomerReviewSettings */.vV)(storeId));
        }
    }, [
        storeId
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var storeInfo = store || storeData;
        var route = (0,routes.getRoute)(routes.PATH.PRODUCT, storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain);
        if (!isRedirectedToHome.current && storeInfo.store_id && storeInfo.domain_info.status === 2 && !route.includes(location.pathname)) {
            isRedirectedToHome.current = true;
            router.replace(route);
        }
    }, [
        storeData
    ]);
    (0,react.useEffect)(function() {
        if (storeId && shouldLoadFeatureLocks) dispatch((0,common/* fetchFeatureLocks */.Fc)(storeId));
    }, [
        storeId,
        shouldLoadFeatureLocks
    ]);
    var loginBtnClick = function() {
        setShowState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showRedirectionModal: true
            });
        });
    };
    var showIframeView = function() {
        dispatch((0,common/* toggleInaccessibleView */.g7)(true));
        setShowState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showInaccessibleView: false
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    shouldBlockRobots(hostname) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex, nofollow"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: keywords
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: OGTitle || title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: OGDescription || metaDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: OGImage || Icon || constants_images/* DEFAULT_SSR_IMAGE_URL */.a
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:width",
                        content: "300"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:height",
                        content: "300"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: OGTitle || title,
                        id: "twittertitle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: OGDescription || metaDescription,
                        id: "twitterdescription"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: OGImage || Icon || constants_images/* DEFAULT_SSR_IMAGE_URL */.a,
                        id: "twitterimage"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "google-site-verification",
                        content: getGoogleSiteVerificationTag()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        dangerouslySetInnerHTML: {
                            __html: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n      })(window,document,'script','dataLayer', \"".concat((store === null || store === void 0 ? void 0 : (ref2 = store.store_marketing_tags) === null || ref2 === void 0 ? void 0 : ref2.g_tag) || "GTM-N8T6CPZ", '")')
                        }
                    }),
                    (store === null || store === void 0 ? void 0 : (ref3 = store.store_marketing_tags) === null || ref3 === void 0 ? void 0 : ref3.fb_domain_verification) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "facebook-domain-verification",
                        content: store === null || store === void 0 ? void 0 : (ref4 = store.store_marketing_tags) === null || ref4 === void 0 ? void 0 : ref4.fb_domain_verification
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: canonicalTagUrl || "".concat(store === null || store === void 0 ? void 0 : (ref5 = store.store_info) === null || ref5 === void 0 ? void 0 : ref5.store_url).concat((0,routes.getDefaultCanonicalUrl)(router === null || router === void 0 ? void 0 : router.asPath))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "shortcut icon",
                        type: "image/png",
                        href: (storeData === null || storeData === void 0 ? void 0 : storeData.favicon) || constants_images/* DEFAULT_SSR_IMAGE_URL */.a
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "192x192",
                        href: (store === null || store === void 0 ? void 0 : (ref6 = store.store_info) === null || ref6 === void 0 ? void 0 : ref6.logo_image) || (storeData === null || storeData === void 0 ? void 0 : storeData.favicon) || constants_images/* DEFAULT_SSR_IMAGE_URL */.a
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "512x512",
                        href: (store === null || store === void 0 ? void 0 : (ref7 = store.store_info) === null || ref7 === void 0 ? void 0 : ref7.logo_image) || (storeData === null || storeData === void 0 ? void 0 : storeData.favicon) || constants_images/* DEFAULT_SSR_IMAGE_URL */.a
                    }),
                    isBuilder && (globalSettingConstant/* FONT_DROPDOWN */.W9 === null || globalSettingConstant/* FONT_DROPDOWN */.W9 === void 0 ? void 0 : globalSettingConstant/* FONT_DROPDOWN.map */.W9.map(function(fontData) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("link", {
                            href: fontData === null || fontData === void 0 ? void 0 : fontData.fontCdn,
                            rel: "stylesheet",
                            crossOrigin: "anonymous"
                        }, fontData === null || fontData === void 0 ? void 0 : fontData.fontCdn);
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "manifest",
                        href: "/api/manifest?domain=".concat(encodeURIComponent(store === null || store === void 0 ? void 0 : (ref8 = store.store_info) === null || ref8 === void 0 ? void 0 : ref8.domain), "&banner=").concat(encodeURIComponent(store === null || store === void 0 ? void 0 : (ref9 = store.store_info) === null || ref9 === void 0 ? void 0 : ref9.name), "&logo=").concat(encodeURI(store === null || store === void 0 ? void 0 : (ref10 = store.store_info) === null || ref10 === void 0 ? void 0 : ref10.logo_image), "&favicon=").concat(encodeURI((storeData === null || storeData === void 0 ? void 0 : storeData.favicon) || ""), "&url=").concat(encodeURI(store === null || store === void 0 ? void 0 : (ref11 = store.store_info) === null || ref11 === void 0 ? void 0 : ref11.store_url))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleTags, {
                        store: store,
                        featureLocksStatus: featureLocksStatus
                    }),
                    (store === null || store === void 0 ? void 0 : (ref12 = store.domain_info) === null || ref12 === void 0 ? void 0 : ref12.site_id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        dangerouslySetInnerHTML: {
                            __html: "\n              var _paq = window._paq = window._paq || [];\n              /* tracker methods like \"setCustomDimension\" should be called before \"trackPageView\" */\n              _paq.push(['trackPageView']);\n              _paq.push(['enableLinkTracking']);\n              (function() {\n                var u=\"//matomo.dotshowroom.in/\";\n                _paq.push(['setTrackerUrl', u+'matomo.php']);\n                _paq.push(['setSiteId', ".concat(store === null || store === void 0 ? void 0 : (ref13 = store.domain_info) === null || ref13 === void 0 ? void 0 : ref13.site_id, "]);\n                var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];\n                g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);\n              })();\n            ")
                        }
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    src: "https://www.googletagmanager.com/ns.html?id=".concat(gtmId),
                    height: "0",
                    width: "0",
                    style: {
                        display: "none",
                        visibility: "hidden"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "dd-showrom__layout",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeCss, {}),
                    (isHomePage || isAboutPage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichSnippetStoreDetails, {
                        store: store
                    }),
                    (store === null || store === void 0 ? void 0 : (ref14 = store.domain_info) === null || ref14 === void 0 ? void 0 : ref14.status) !== 2 && toggleMobileView ? !IS_SERVER && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mobile-screen relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inaccessibleLayer-login flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "If you are the owner of this website then"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "login & enable desktop theme"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "login-btn pointer relative dib ml3",
                                        onClick: loginBtnClick,
                                        children: "Log In"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "flex",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                    src: window.location.href,
                                    height: "100%",
                                    width: "100%"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: children
                    }),
                    !!showState.showInaccessibleView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InaccessibleLayer, {
                        store: store,
                        show: showState.showInaccessibleView,
                        redirectToBadShowcase: showIframeView
                    }) : null,
                    !!showState.showRedirectionModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RedirectionToWebConsoleModal, {
                        show: showState.showRedirectionModal
                    }) : null,
                    (storeData === null || storeData === void 0 ? void 0 : (ref15 = storeData.services) === null || ref15 === void 0 ? void 0 : ref15.store_type_flag) === constants/* B2B_STORE_TYPE_CONSTANT */.CB ? /*#__PURE__*/ (0,jsx_runtime.jsx)(B2bRfqFormModal, {
                        productData: (props === null || props === void 0 ? void 0 : props.product) || {}
                    }) : null,
                    (storeData === null || storeData === void 0 ? void 0 : (ref16 = storeData.services) === null || ref16 === void 0 ? void 0 : ref16.exit_gating_flag) && !isLoginByEmail ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitGatingModal, {}) : null,
                    (promoModalState === null || promoModalState === void 0 ? void 0 : promoModalState.show) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoModal, {}),
                    (promoRemovalAlertModalState === null || promoRemovalAlertModalState === void 0 ? void 0 : promoRemovalAlertModalState.show) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoRemovalAlertModal, {}),
                    showWhatsAppLeadModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsAppLeadGenerationModal, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Layout = (Layout);


/***/ }),

/***/ 135069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(506337);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(913886);
/* harmony import */ var _getUrlParams__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(705492);



var checkIfThemeEditorOrPreview = function() {
    return !_checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__/* .IS_SERVER */ .W6 && (window.location.href.includes("showroom-preview") || !!(0,_getUrlParams__WEBPACK_IMPORTED_MODULE_2__/* .getUrlParams */ .D)([
        _constants__WEBPACK_IMPORTED_MODULE_1__/* .PREVIEW_PARAMS.THEME_PAGE */ .I.THEME_PAGE
    ])[_constants__WEBPACK_IMPORTED_MODULE_1__/* .PREVIEW_PARAMS.THEME_PAGE */ .I.THEME_PAGE]);
};
/* harmony default export */ __webpack_exports__["Z"] = (checkIfThemeEditorOrPreview);


/***/ }),

/***/ 284320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ DEFAULT_SSR_IMAGE_URL; }
/* harmony export */ });
var DEFAULT_SSR_IMAGE_URL = "https://cdn.dotpe.in/kiranaStatic/image/default-ssr-icon-22092020.png";


/***/ })

}]);